import * as types from './staff.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	get: payload => ({
		type: types.GET_STAFF,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_STAFF,
		payload,
	}),
	set: payload => ({
		type: types.SET_STAFF,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_STAFF,
		payload,
	}),
	getStaticOptions: payload => ({
		type: types.GET_STATIC_OPTIONS,
		payload,
	}),
	getDynamicOptions: payload => ({
		type: types.GET_DYNAMIC_OPTIONS,
		payload,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
